/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_Timing_SettingsInputs */



/**
* | output |
* | --- |
* | "Update timing settings" |
*
* @param {Update_Timing_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_timing_settings = /** @type {((inputs?: Update_Timing_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_Timing_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour les paramètres de minutage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeiteinstellungen aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna le impostazioni di temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить настройки времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar la configuración de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新时间设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミング設定を更新する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय सेटिंग्स अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar configurações de tempo")
	return /** @type {LocalizedString} */ ("Update timing settings")
});